import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../context";

export default function ProductHero({ product, productName }) {
  const { t } = useTranslation();
  const { language } = useAppContext();
  const productKey = {
    "group-saving": "ikimina",
    "u-save": "uSave",
    crowdfund: "crowdfund",
  }[productName];

  return (
    <div
      className="pt-10 bg-[rgb(0,73,69)] min-h-screen bg-radial-gradient"
      id="home"
    >
      <div className="container mx-auto px-6 pt-12 grid lg:grid-cols-2 gap-10 items-center">
        {/* Animate left side */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="text-4xl font-bold text-white mb-6">
            {t(`singleProductPage.${productKey}.heroSection.title`)}
          </h1>
          <p className="text-white/80 text-lg mb-8">
            {t(`singleProductPage.${productKey}.heroSection.description`)}
          </p>
          {/*  Buttons */}
          <motion.div
            className="flex flex-wrap gap-2.5 text-sm sm:text-base"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
          >
            <a
              href="#download"
              className="cursor-pointer bg-white text-defaultGreen  px-4 py-3 rounded-lg flex items-center gap-2 font-bold active:scale-95 transition-all duration-300"
            >
              {t("heroSection.getStarted")}
            </a>
            <a
              href="#workflow"
              className="cursor-pointer text-white px-4 py-3 rounded-lg flex items-center gap-2  font-bold border border-white hover:bg-white transition-all duration-300 hover:text-defaultGreen active:scale-95"
            >
              {t("heroSection.seeHowItWorks")}
            </a>
          </motion.div>
        </motion.div>
        {/* Animate hero image */}
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
        >
          <div className="p-8 relative">
            <motion.img
              src={product.images.heroImage[language]}
              alt={t(`singleProductPage.${productKey}.heroSection.title`)}
              className="w-full"
              transition={{
                duration: 3,
                ease: "easeInOut",
              }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
